import moment from "moment";
import Image from "next/image";
import React, { useMemo, useState } from "react";
import { deleteIcon } from "../../../../assets/icons";
import CalendarModal from "../../../elements/calendar";
import Card from "../../../elements/card";
import Input from "../../../elements/input";
import DropDown from "../../../elements/select";
import MultiSelect from "../../../elements/multi-select";
import { ErrorMessage, Formik } from "formik";
import Button from "../../../elements/button";
import { addCoupon, editCoupons } from "../../../../api-client/my-product";
import { useQuery } from "react-query";
import { useCookies } from "react-cookie";
import { getAllVendorProducts } from "../../../../api-client/setup-contest";
import { setAuthHeader } from "../../../../utils/local-storage";
import { toast } from "react-toastify";
import { capitalize } from "../../../../utils/formatters";

const EditCouponModal = ({ setEditCouponModal, currentProduct }) => {
  const [closeCalendar, setCloseCalendar] = useState(true);
  const [loading, setLoading] = useState(false);
  const [cookies, setCookie] = useCookies();

  //   Destructure Product Data
  const {
    couponCode,
    discount,
    discountType: type,
    products: productsData,
    endDate,
    startDate,
  } = currentProduct;

  const contestData = [
    { label: "Jet black", value: "jetty" },
    { label: "But win", value: "butty" },
    { label: "Yit klopp", value: "yitty" },
    { label: "Pet cookie", value: "petty" },
    { label: "Kettle colt", value: "ketty" },
  ];

  const discountType = [
    { label: "Percentage", value: "percentage" },
    { label: "Amount", value: "amount" },
  ];

  const [disType, setDistype] = useState(capitalize(type));
  const [value, setValue] = useState("");
  const [productValue, setProductValue] = useState([]);
  const [productToken, setProductToken] = useState(productsData?.productToken);
  const [date, setDate] = useState([new Date(startDate), new Date(endDate)]);

  // Fetch product categories
  const { data: products, isLoading } = useQuery("all-products", () =>
    getAllVendorProducts(cookies?.authToken)
  );

  // products dropdown Content
  const productData = useMemo(() => {
    return products?.data?.data?.getProduct.map((category, index) => ({
      label: category.name,
      value: category.productToken,
    }));
  }, [products]);

  const handleAddCoupon = async (data) => {
    const { discount, code } = data;
    const formData = {
      productToken: productToken,
      discount: discount,
      discountType: value,
      code: code,
      startDate: moment(date[0]?.toDateString()).format("MM-DD-YYYY"),
      endDate: moment(date[1]?.toDateString()).format("MM-DD-YYYY"),
    };

    const mainData = {
      authToken: cookies.authToken,
      values: formData,
    };

    setLoading(true);

    setAuthHeader(cookies.authToken);
    try {
      const res = await editCoupons(mainData);
      toast.success(res.data.message);
      setEditCouponModal(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error.response.data.message);
    }
  };

  const handleApply = () => {
    setCloseCalendar(true);
  };

  return (
    <section className="lg:h-full  w-screen z-50 bg-[#205363] flex items-center justify-center fixed top-0 left-0 bg-opacity-[48%]">
      {!closeCalendar && (
        <CalendarModal
          closeCalendar={setCloseCalendar}
          date={date}
          setDate={setDate}
          selectRange={true}
          handleApply={handleApply}
        />
      )}

      <div className=" lg:w-[763px]  mx-2 relative">
        <Formik
          // Initialise Initial Form Values
          initialValues={{
            discount: discount, // add initial value for discount
            code: couponCode, // add initial value for code
          }}
          // Submit Function
          onSubmit={async (data) => {
            handleAddCoupon(data);
          }}
        >
          {({ values, handleChange, handleSubmit, errors, touched }) => (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <div className="flex items-center justify-between">
                <div></div>
                <div className="flex items-center justify-between  lg:absolute right-[0%] top-[0%]">
                  <button onClick={() => setEditCouponModal(false)}>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_7374_19071)">
                        <path
                          d="M24.3167 13.332L20 17.6487L15.6834 13.332L13.3334 15.682L17.65 19.9987L13.3334 24.3154L15.6834 26.6654L20 22.3487L24.3167 26.6654L26.6667 24.3154L22.35 19.9987L26.6667 15.682L24.3167 13.332ZM20 3.33203C10.7834 3.33203 3.33337 10.782 3.33337 19.9987C3.33337 29.2154 10.7834 36.6654 20 36.6654C29.2167 36.6654 36.6667 29.2154 36.6667 19.9987C36.6667 10.782 29.2167 3.33203 20 3.33203ZM20 33.332C12.65 33.332 6.66671 27.3487 6.66671 19.9987C6.66671 12.6487 12.65 6.66536 20 6.66536C27.35 6.66536 33.3334 12.6487 33.3334 19.9987C33.3334 27.3487 27.35 33.332 20 33.332Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_7374_19071">
                          <rect width="40" height="40" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                </div>
              </div>
              <div className="bg-white lg:h-[800px]  lg:px-10 px-5 py-10 lg:mx-0 mx-2 lg:my-6 lg:w-[710px] rounded-[30px]">
                <div className="mb-7 mt-10 flex items-center justify-center flex-col">
                  <p>
                    <svg
                      width="47"
                      height="47"
                      viewBox="0 0 67 54"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M66.8334 20.332V6.9987C66.8334 3.2987 63.8334 0.332031 60.1668 0.332031H6.83342C3.16675 0.332031 0.200081 3.2987 0.200081 6.9987V20.332C3.86675 20.332 6.83342 23.332 6.83342 26.9987C6.83342 30.6654 3.86675 33.6654 0.166748 33.6654V46.9987C0.166748 50.6654 3.16675 53.6654 6.83342 53.6654H60.1668C63.8334 53.6654 66.8334 50.6654 66.8334 46.9987V33.6654C63.1668 33.6654 60.1668 30.6654 60.1668 26.9987C60.1668 23.332 63.1668 20.332 66.8334 20.332ZM60.1668 15.4654C56.2001 17.7654 53.5001 22.0987 53.5001 26.9987C53.5001 31.8987 56.2001 36.232 60.1668 38.532V46.9987H6.83342V38.532C10.8001 36.232 13.5001 31.8987 13.5001 26.9987C13.5001 22.0654 10.8334 17.7654 6.86675 15.4654L6.83342 6.9987H60.1668V15.4654ZM30.1667 36.9987H36.8334V43.6654H30.1667V36.9987ZM30.1667 23.6654H36.8334V30.332H30.1667V23.6654ZM30.1667 10.332H36.8334V16.9987H30.1667V10.332Z"
                        fill="#58D96B"
                      />
                    </svg>
                  </p>
                  <h2 className="text-md mt-5 mb-8 font-medium">Edit Coupon</h2>
                </div>
                <div>
                  <h3 className="font-medium mb-2 text-[#828282]">
                    Coupon Duration
                  </h3>
                  <Input
                    type="text"
                    className="rounded-[6px] text-[#828282]"
                    placeholder="Enter coupon duration"
                    onFocus={() => setCloseCalendar(false)}
                    value={`${moment(date[0].toDateString()).format(
                      "DD/MM/YYYY"
                    )} - ${moment(date[1].toDateString()).format(
                      "DD/MM/YYYY"
                    )}`}
                  />
                </div>

                <div className="grid grid-cols-2 gap-3 mt-5">
                  <div>
                    <h3 className="font-medium mb-2  text-[#828282]">
                      Discount Type
                    </h3>
                    <DropDown
                      options={discountType}
                      value={value}
                      selected={disType}
                      setSelected={setDistype}
                      setValue={setValue}
                    />
                  </div>
                  <div>
                    <h3 className="font-medium mb-2 text-[#828282]">
                      Discount Value
                    </h3>
                    <Input
                      placeholder="Enter value for Coupon"
                      type="number"
                      className="text-[#828282] rounded-[6px]"
                      name="discount"
                      onChange={handleChange}
                      value={values.discount}
                      error={errors.discount && touched.discount}
                    />
                  </div>
                </div>
                <div>
                  <h3 className="font-medium mb-2 text-[#828282] mt-5">
                    Product for Coupon
                  </h3>
                  <MultiSelect
                    className="rounded-[6px]"
                    options={productData}
                    value={productToken}
                    selected={productToken}
                    setSelected={setProductToken}
                    setValue={setProductToken}
                  />
                </div>
                <div>
                <h3 className="font-medium mb-2 text-[#828282] mt-5 ">Coupon Code</h3>
                  <Input
                    placeholder="Enter your unique coupon code"
                    type="text"
                    className="rounded-[6px]"
                    name="code"
                    onChange={handleChange}
                    value={values.code}
                    error={errors.code && touched.code}
                  />
                </div>
                <div className="mt-10 mb-10">
            <div className="flex items-center  flex-col md:flex-row flex-wrap">
              <div className=" lg:w-auto w-full ">
                      <Button
                        label="Accept"
                 className="btn-primary py-5 px-3 border lg:w-[315px] w-full"
                        type="submit"
                        onClick={() => console.log("clicky")}
                        loading={loading}
                      />
                    </div>
                    <div className="ml-0 md:ml-2 mt-3 md:mt-0 lg:w-[315px] w-full self-end ">
                      <Button
                        label="Cancel"
                        className="py-5 px-3 border border-primary w-full"
                        onClick={() => setEditCouponModal(false)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </section>
  );
};

export default EditCouponModal;
